import script from "./SuspanceHistery.vue?vue&type=script&setup=true&lang=js"
export * from "./SuspanceHistery.vue?vue&type=script&setup=true&lang=js"

import "./SuspanceHistery.vue?vue&type=style&index=0&id=0f06e29e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f06e29e"]])

export default __exports__